<template>
	<div>
		<template v-if="loadedCSV">
			<div class="clearfix mb-2">
				<h2 class="float-left">
					<template>
						{{ $t('third-party-data-import') }}
					</template>
				</h2>
				<div class="text-right float-right">
					<div class="form-inline">
						<button class="btn btn-primary" @click="saveTable"
							:disabled="!isSaveDisabled">{{ $t('save') }}</button><!--@click="saveTransferData"-->
					</div>
				</div>
			</div>
			<div class="sticky-container">
				<table class="table table-bordered table-timetable">
					<thead>
                        <!--BEGIN FIELD CREATION-->
						<tr>
							<th style="min-width: 200px;"></th><!--class="header"-->
							<th v-for="(header, index) in csvCols" :key="index">
								<select v-model="colAssign[index]" @change="handleSelection(index)">
									<option value="">{{ $t('select-caps') }}</option>
									<option value='ignore'>{{ $t('ignore') }}</option>
									<option value="create">{{ $t('create') }}</option>
									<option v-for="(col, key) in existingCols" :value="col" :key="key"
										:disabled="isOptionDisabled(col, key)">
										{{ col.caption }}
									</option>
								</select>
							</th>
						</tr>
                        <!--END FIELD CREATION-->
                        <!-- BEGIN DATATYPE-->
                        <tr>
							<th style="min-width: 200px;"></th><!--class="header"-->
							<th v-for="(value,index) in csvCols" :key="index">
                                <select v-model="datatype[index]"
                                    :disabled="colAssign[index] == 'ignore' || colAssign[index] == ''"
                                >
                                    <option value="" selected>{{ $t('datatype') }}</option>
                                    <option value="0">{{ $t('number') }}</option>
                                    <option value="1">{{ $t('date') }}</option>
                                </select>

							</th>
						</tr>
                        <!--END DATATYPE-->
						<tr>
							<th></th>
							<th v-for="(header, index) in csvCols" :key="index" :class="{
									'nonExistingColumn': !existingColsArr.includes(header) && !(colAssign[index] === 'ignore'),
									'ignoredColumn': colAssign[index] === 'ignore'
								}">
                                <div class="d-flex align-items-center justify-content-between">
                                    <template v-if="colAssign[index] === 'create'">
                                        <input type="text" v-model="createdCols[index]" :placeholder="header" />
                                    </template>
                                    <template v-else>
                                        {{ header }}
                                    </template>
                                    <b-icon icon="calendar-event" v-if="datatype[index]==1"></b-icon>
                                </div>
							</th>

						</tr>
					</thead>
					<tbody>
						<tr v-for="(row, index) in loadedCSV.slice(1)" :key="index" :ref="datastudents[index].id">
							<td>
								<div class="input-group input-group-sm">
									<input type="text" v-model="datastudents[index].displayName" class="form-control"
										@focus="selectStudent(index)"
										:style="datastudents[index].displayName === null ? 'border-color: #ef4444' : ''" />
									<div class="input-group-append">
										<span class="input-group-text" id="inputGroupPrepend3"
											@click="deselectStudent(index)"><b-icon icon="trash-fill"
												aria-hidden="true"></b-icon></span>
									</div>
								</div>
							</td>
							<td v-for="(value, columnIndex) in row" :key="columnIndex">{{ value }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</template>
		<template v-else>
			<b-form-file multiple v-model="files" :state="Boolean(files)"
				:placeholder="$t('choose-file-or-drop-here-ellipses')" :drop-placeholder="$t('drop-file-here-ellipses')"
				accept=".csv," ref="comment-files" data-cy="upload-file-input" @input="handleCSV"
				class="mb-4"></b-form-file>
		</template>
	</div>
</template>

<script>
import Papa from 'papaparse';

export default {
	components: {
	},
	data() {
		return {
			colAssign: {},
            datatype: {},
			files: [],
			loadedCSV: null,
			datatransfer: {
				cols: {},
				data: {}
			},
			datastudents: [],
			existingCols: {},
			existingColsArr: [],
			csvCols: null,
			cellsData: {},
			createdCols: [],
			exclusionList: ['Student'],
            isDate:{}
		}
	},

	mounted() {
		if (this.isNew) {
			this.loaded = true;
		}
		this.$users.getStudents.call(this).then(students => {
			this.students = students;
		})
		this.getExisitingCols();
	},
	methods: {
		getExisitingCols() {
			//get existing columns from the API endpoint and saves them into an aray
			this.$cfetch(`${this.$settings.APIBaseURL}/thirdpartydata/getcols`)
				.then(res => {
					this.existingCols = res.result;
					this.existingColsArr = Object.keys(this.existingCols).map(key => res.result[key].caption);
				});
		},
		handleSelection(index) {
			//Save all the created columns
			if (this.colAssign[index] == 'create' && this.csvCols[index] !== null) {
				this.createdCols[index] = this.csvCols[index];
			}

            if(this.colAssign[index] != 'ignore' || this.colAssign[index] != '') this.$set(this.datatype, index, '');

            if(this.colAssign[index] == 'ignore') this.$delete(this.datatype, index);
			this.selectChanged = true;
		},
		async saveTable() {
       
			/*Check if the user has decided to create new columns,
		    if so, we make an API call to add them to the DB*/
			if (this.createdCols.length > 0) {
				for (const [index, col] of this.createdCols.entries()) {
					if (col !== '') {
						await this.addColumn(col, index);
					}
				}
				this.mapTable();
			} else {
				this.mapTable();
			}
		},
		mapTable() {
			this.cellsData = {};
			/* We map the CSV array into an object. Note that the data is being labeled
				with the student and datapoint ids, respectively */
			this.loadedCSV.slice(1).forEach((row, index) => {
				const student = this.datastudents[index];
				const studentId = student.id;
				if (studentId !== null) {
					if (!this.cellsData[studentId]) {
						this.cellsData[studentId] = {};
					}
				}

				Object.keys(row).forEach((columnIndex) => {
					const selectedOption = this.reactiveColAssign[columnIndex];
					// Exclude ignored columns and rows without students
					if(selectedOption && selectedOption.id && studentId !== null &&

						selectedOption !== 'ignore' && row[columnIndex] !== null) {
						const colId = selectedOption.id;

                        if(row[columnIndex] == null || row[columnIndex] == ''){
                            this.cellsData[studentId][colId] = {
                                value: null,
                                datetime: null
                            };
                        } else {
                            if(this.isValidDateTime(row[columnIndex])){
                                this.cellsData[studentId][colId] = {
                                    value: null,
                                    datetime: this.formatDatetimeToYmdHis(row[columnIndex])
                                } 
                            } else {
                                this.cellsData[studentId][colId] = {
                                    value: row[columnIndex],
                                    datetime: null
                                }  
                            }
                        }
					}
				});
			});


			// We save the object in the DB
			if (Object.keys(this.cellsData).length > 0) {
				this.saveTransferData(this.cellsData);
			}
		},
		isOptionDisabled(option, currentIndex) {
			//checks if the option was alredy selected
			for (let i = 0; i < currentIndex; i++) {
				if (this.colAssign[i] === option) {
					return true;
				}
			}
			return false;
		},
		handleCSV() {
			this.files.forEach((item) => {
				if (item.type === 'text/csv') {
					new Promise((resolve, reject) => {
						Papa.parse(item, {
							complete: res => {
								this.loadedCSV = res.data;
                                //Hydrate
								this.loadedCSV.slice(1).forEach((row, index) => {

									this.$set(this.datastudents, index, {
										id: null,
										displayName: null
									});
                                });
                                //Check if a column is a datetime entry
                                this.loadedCSV[1].forEach((item,index) => {

                                    const nullItem =  item == null || item == '';

                                    if(this.isValidDateTime(item)){
                                        this.isDate[index]= true;
                                    } else {
                                        this.isDate[index]= false;
                                    }

                                    if(nullItem) this.isDate[index]= null;
                                });
								resolve(this.loadedCSV);
							},
							error: error => {
								console.error('Error parsing CSV file:', error);
								reject(error);
							}
						});
					})
						.then(parsedCSV => {
							// Save the columns from the CSV file
							this.csvCols = parsedCSV[0];
							this.createdCols = Array(this.csvCols.length).fill('');

                            //Hydrate datatype
                            this.hydrateDatatype();
							// Assign values to colAssign based on matching headers in existingCols,
							//if any of the elements is in the exclusionList, then its select is set to ignore
							this.csvCols.forEach((header, index) => {
								let found = false;
								for (const key in this.existingCols) {
									const existingCol = this.existingCols[key];
									if (existingCol.caption === header) {
										this.$set(this.colAssign, index, existingCol);
										found = true;
										break;
									}
								}
								if (!found) {
									if (this.exclusionList.includes(header)) {
										this.$set(this.colAssign, index, 'ignore');
									} else {
										this.$set(this.colAssign, index, '');
									}
								}
							});
						})
						.catch(error => {
							console.error('Error parsing CSV file:', error);
						});
				}
			});
		},
		selectStudent(index) {
			const self = this;
			this.$users.getStudents.call(this).then(students => {
				this.$store.commit("openModal", {
					type: "selector",
					title: this.$t("select-a-student"),
					selectCallback: function (selection) {
						self.datastudents[index].id = selection.id;
						self.datastudents[index].displayName = selection.displayName;
						self.$store.commit("closeModal");
					},
					selected: [
						{
							id: self.datastudents[index].id
						}
					],
					data: students,
					captionKey: "displayName",
                    subcaptionKey: "studentid",
					studentSearchFilters: true
				});
			});
		},
		deselectStudent(index) {
			this.datastudents[index].id = null;
			this.datastudents[index].displayName = null
		},
		checkRepeatedColId(input) {
			for (let index in this.existingCols) {
				if (input == this.existingCols[index].name) {
					return true;
				}
			}
		},
		checkBlankColName: function (input) {
			if (input === '-' || input === '') {
				return true;
			}
			else {
				return false;
			}
		},
		addColumn(input, index) {
			return new Promise((resolve, reject) => {
                var name = input.toLowerCase().trim().replace(/[^a-z0-9]+/g, '_').replace(/^_+/, '').replace(/_+$/, '');
				if (this.checkRepeatedColId(name)) {
					this.$store.commit("openDialog", {
						title: this.$t("oops"),
						content: this.$t("column-name-already-in-use")
					});
					reject();
				} else if (this.checkBlankColName(name)) {
					this.$store.commit("openDialog", {
						title: this.$t("oops"),
						content: this.$t("the-name-can-not-be-empty")
					});
					reject();
				} else {
					this.$cfetch(`${this.$settings.APIBaseURL}/thirdpartydata/save`, {
						data: {
							id: null,
							name: name,
							caption: input,
                            datatype: this.datatype[index]
						},
						method: 'post'
					}).then((res) => {
						if (res.status === "SUCCESS") {
							const colKey = index;
							this.$set(this.colAssign, colKey, res.result);
							resolve();
						} else {
							if (res.error_message) {
								this.error = res.error_message;
							} else {
								this.error = this.$t("failed-load-table");
							}
							reject();
						}
					}).catch((err) => {
                        console.error(err)
                        this.$log.error.call(this, err)
                    });
				}
			})
		},
		saveTransferData(input) {
            // Attach the column ids to the datatype
            for(let index in this.datatype){
                let type = this.datatype[index];
                let colId = this.colAssign[index].id;

                this.datatype[colId] = type;

                //if(Number(index) !== Number(colId)) delete this.datatype[index];

            }
            
            
			this.$cfetch(`${this.$settings.APIBaseURL}/thirdpartydata/savevalues`, {
				method: 'post',
				data: {
					values: input,
                    datatype: this.datatype
				}
			}).then((res) => {
				if (res.status === "SUCCESS") {
					this.$store.commit("openDialog", {
						title: this.$t("save"),
						content: this.$t("the-table-was-succesfully-saved"),
						confirmCallBack: function () {
							this.$router.replace("/thirdparty/edit");
						}
					});
				} else {
					if (res.error_message) {
						this.error = res.error_message;
					} else {
						this.error = this.$t("failed-to-save-values");
					}
				}
			});
		},
        isValidDateTime(datetimeString) {
            // Regular expression for Y-m-d H:i:s  format
            const datetimeRegex = /^\d{4}[-\/]\d{2}[-\/]\d{2} \d{2}:\d{2}:\d{2}$/; //eslint-disable-line
            const dateRegex = /^\d{4}[-\/]\d{2}[-\/]\d{2}$/; //eslint-disable-line
            const excelRegex = /^(0[1-9]|1[0-2])\/(0[1-9]|[12][0-9]|3[01])\/\d{4}$/; //eslint-disable-line

            return datetimeRegex.test(datetimeString) || excelRegex.test(datetimeString)
                || dateRegex.test(datetimeString) ;
        },
        formatDatetimeToYmdHis(inputDate) {
            // Ensure that the inputDate is a Date object
            if (!(inputDate instanceof Date)) {
                inputDate = new Date(inputDate);
            }
            // Get individual components
            const year = inputDate.getFullYear();
            const month = String(inputDate.getMonth() + 1).padStart(2, '0'); // Because months are zero-based
            const day = String(inputDate.getDate()).padStart(2, '0');
            const hours = String(inputDate.getHours()).padStart(2, '0');
            const minutes = String(inputDate.getMinutes()).padStart(2, '0');
            const seconds = String(inputDate.getSeconds()).padStart(2, '0');

            // Format the date string
            const formattedDate = hours !== '00' || minutes !== '00' || seconds !== '00'
                ? `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
                : `${year}-${month}-${day} 00:00:01`;

            return formattedDate;
        },
        hydrateDatatype(){
            for (let index in this.csvCols){
                this.$set(this.datatype, index, '')
            }
        }
	},
	computed: {
		isSaveDisabled() {
			const isSelectAssigned = Object.values(this.colAssign).every(
				(value) => value !== ''
			);
            const isDatatypeAssigned = Object.values(this.datatype).every(
				(value) => value !== ''
			);
			const isStudentSelected = this.datastudents.some(
				(student) => student.displayName !== null
			);


			return isSelectAssigned && isDatatypeAssigned && isStudentSelected;
		},
		reactiveColAssign() {
			return this.colAssign;
		}
	}
};
</script>
<style>
.nonExistingColumn {
	background-color: #f97316 !important
}

.ignoredColumn {
	background-color: #ef4444 !important
}
</style>
